// 唤起企点客服QQ聊天mixins
export default {
	methods: {
		// 通过指定id唤起企点客服QQ
		handleEvokeQQ() {
			const id = document.getElementById('service-01')
			if (id) {
				// 模拟点击
				id.click()
			} else {
				console.error('未找到客服按钮元素')
			}
		}
	}
}
